// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router/routes'
import store from './store/index'
import VueLocalStorage from 'vue-ls'

import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
Vue.use(VueMaterial)

import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
Vue.use(VueSidebarMenu)

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
Vue.component('multiselect', Multiselect);

Number.prototype.toFixedDown = function(digits) {
  var re = new RegExp('(-{0,1}\\d+\\.\\d{' + digits + '})(\\d)')
  var m = this.toString().match(re)
  return m ? parseFloat(m[1]) : this.valueOf()
}

Vue.config.productionTip = process.env.NODE_ENV === 'production';

Vue.use(VueLocalStorage)

// Conditionally load the custom theme CSS file
const theme = process.env.SITE_TYPE === 'GAES' ? 'gaes' : 'default';
const link = document.createElement('link');
link.rel = 'stylesheet';
link.href = '/static/css/' + theme + '-theme.css';
document.head.appendChild(link);

router.beforeEach((to, from, next) => {
  setTimeout(() => {
    document.querySelectorAll('.cov-datepicker').forEach(inp => {
      inp.value = ''
    })
  }, 10)
  store.state.fill = true  
  const user = Vue.ls.get('user')  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!user) {      
      next({
        path: '/',
        // query: { redirect: to.fullPath } // commented by abeel; 
      })
    } else {
      next()
    }
  } else {
    next()
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  created: function () {
    if (Vue.ls.get('user')) {
      store.commit('SET_USER', Vue.ls.get('user'))
    }
    
    const title = document.createElement('title');
    title.innerText = process.env.SITE_TYPE === 'GAES' ? 'Ductos GAES' : 'Pipe Eagle';
    document.head.appendChild(title);
    this.healthCheck();
  },
  methods: {
    healthCheck: function () {
      const url = process.env.API_BASE_URL + 'version';
      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then(response => {
        if (response.status !== 200) {
          console.log('Error de conexión con el servidor ' + response.status);
        }
      }).catch(error => {
        console.log(error);
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js